import { useSelector } from "react-redux";
import ApplicationTrackerforApplicant from "./ApplicationTrackerforApplicant";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  getAppliedJobById,
  getAppliedJobs,
  getInterviewRounds,
  getOfferLetter,
  saveParticularJob,
} from "../../../../Redux/Reducers/JobReducer";
import {
  Box,
  Typography,
  CircularProgress,
  Grid,
  Card,
  IconButton,
  Button,
  Modal,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Stepper,
  Step,
  StepLabel,
  InputAdornment,
  Pagination,
} from "@mui/material";
import { useQuantityContext } from "../../../QuantityContext";
import { useCallback, useState } from "react";
import ShareIcon from "@mui/icons-material/Share";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import { WorkOutline, LocationOn, Search } from "@mui/icons-material";
import SchoolIcon from "@mui/icons-material/School";
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { ShareProfile } from "../ProfileConnectionComponents";

const AppliedSaveJob = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { openSnackbar } = useQuantityContext();
  const ApplicantsPage = useSelector((state) => state?.jobs?.appliedJobs) || [];
  const appliedJobs = ApplicantsPage?.appliedJobs;

  console.log("appliedJobs", appliedJobs);

  const savedJobs = appliedJobs?.filter((job) => job.is_saved === true);

  const handleSingleApplicantClick = (job) => {
    dispatch(getAppliedJobById(job?.job_id));
    if (job?.application_status?.includes("Offer")) {
      dispatch(getOfferLetter(job?.id));
    } else if (
      job?.application_status == "Interview In-Progress" ||
      job?.application_status == "Selected"
    ) {
      dispatch(getInterviewRounds(job?.id));
    }
    navigate(`/applicant-page/${job?.job_id}`);
  };

const renderPostedDate = (date) => {
  const postedDate = new Date(date);
  const now = new Date();
  const diffInMs = now - postedDate;

  const diffInMinutes = Math.floor(diffInMs / (1000 * 60));
  const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));
  const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
  const diffInMonths = Math.floor(diffInDays / 30);
  const diffInYears = Math.floor(diffInDays / 365);

  if (diffInMinutes < 1) {
    return "just now";
  } else if (diffInMinutes < 60) {
    return `${diffInMinutes}m ${diffInMinutes === 1 ? "" :""} ago`;
  } else if (diffInHours < 24) {
    return `${diffInHours}h ${diffInHours === 1 ? "" : ""} ago`;
  } else if (diffInDays === 1) {
    return "1d ago";
  } else if (diffInDays < 30) {
    return `${diffInDays}d ago`;
  } else if (diffInMonths < 12) {
    return `${diffInMonths}m ${diffInMonths === 1 ? "" : ""} ago`;
  } else {
    return `${diffInYears}y ${diffInYears === 1 ? "" : ""} ago`;
  }
};
  const handleSuccess = (message, severity = "success", autoClose = 6000) => {
    openSnackbar(message, severity, autoClose);
  };

  const handleFailure = (message, severity = "error", autoClose = 6000) => {
    openSnackbar(message, severity, autoClose);
  };

  const [shareProfileConfig, setShareProfileConfig] = useState({
    open: false,
    onClose: undefined,
    qrCodeUrl: "",
    qrCodeLogo: undefined,
    showQr: true,
    isDownload: false,
    profileType: "",
    handleSuccess: handleSuccess,
    handleFailure: handleFailure,
  });

  const updateShareProfileConfig = (newConfig) => {
    setShareProfileConfig((prev) => ({
      ...prev,
      ...newConfig,
    }));
  };

  const handleJobShare = (job) => {
    updateShareProfileConfig({
      open: true,
      onClose: () =>
        setShareProfileConfig((prev) => ({ ...prev, open: false })),
      qrCodeUrl: `${process.env.REACT_APP_CARD_URL}/job-description/${job.id}`,
      showQr: false,
      profileType: "Job",
      handleSuccess,
      handleFailure,
    });
  };

  const handleJobSave = useCallback(
    (jobId) => {
      dispatch(saveParticularJob(jobId))
        .unwrap()
        .then(() => {
          openSnackbar("Job saved successfully!", "success");
          dispatch(getAppliedJobs()); // Refresh jobs list to update UI
        })
        .catch((error) => {
          openSnackbar("Failed to save job", "error");
        });
    },
    [dispatch]
  );

  const formatSalary = (salary) => {
    if (!salary) return "Not Specified"; // If salary is null, undefined, or empty string, return "Not Specified"

    // Check if the salary is already in 'k' format (e.g., '50k', '150k')
    if (/^\d+(\.\d+)?k$/.test(salary)) {
      return salary; // If it's in 'k' format, return the salary as is
    }

    // Check if the salary is a range (e.g., "10000-20000")
    const salaryParts = salary?.split("-");

    if (salaryParts?.length === 2) {
      const minSalary = parseInt(salaryParts[0].replace(/,/g, ""));
      const maxSalary = parseInt(salaryParts[1].replace(/,/g, ""));

      // Check if both values are valid numbers
      if (isNaN(minSalary) || isNaN(maxSalary)) {
        return "Not Specified"; // If either value is NaN, return "Not Specified"
      }

      // Convert salary range to 'k' format
      return `${minSalary / 1000}k - ${maxSalary / 1000}k`;
    } else {
      const salaryInK = parseInt(salary.replace(/,/g, ""));

      // If the salary is not a valid number, return "Not Specified"
      if (isNaN(salaryInK)) {
        return "Not Specified";
      }

      return `${salaryInK / 1000}k`; // If it's a single salary, convert to 'k' format
    }
  };

    const parseSkillsArray = (data) => {
    if (!data) return [];

    try {
      // First attempt to parse as JSON
      const parsedData = JSON.parse(data);
      return Array.isArray(parsedData) ? parsedData : [];
    } catch (error) {
      // If JSON parsing fails, check if it's a comma-separated string
      if (typeof data === "string") {
        return data?.split(",")?.map((skill) => skill.trim());
      }
      // If it's already an array
      if (Array.isArray(data)) {
        return data;
      }
      return [];
    }
  };

  return (
    <Box sx={{ p: 3 }}>
      {savedJobs?.length === 0 ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "200px",
          }}
        >
          <Typography variant="h6" color="text.secondary">
            No saved jobs found
          </Typography>
        </Box>
      ) : (
        <Grid container spacing={2}>
          {savedJobs?.map((job) => (
            <Grid item xs={12} sm={6} md={3} key={job?.id}>
              <Card
                sx={{
                  boxShadow: 3,
                  borderRadius: 2,
                  width: "100%",
                  height: "min(60vh, 420px)",
                  position: "relative",
                  p: 3,
                  pb: "60px",
                  transition: "transform 0.2s, box-shadow 0.2s",
                  "&:hover": {
                    // transform: "translateY(-5px)",
                    border: "1px solid #0045C6",
                    boxShadow: 5,
                  },
                }}
              >
                <Box
                  sx={{
                    position: "absolute",
                    top: 8,
                    right: 8,
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                  }}
                >
                  <Typography
                    variant="caption"
                    color="gray"
                    sx={{ fontWeight: 500, fontSize: "12px" }}
                  >
                    {renderPostedDate(job?.date_of_apply)}
                  </Typography>
                  <IconButton
                    size="small"
                    aria-label="share"
                    onClick={() => handleJobShare(job)}
                    sx={{ fontSize: "16px" }}
                  >
                    {job?.job_status == "open" ? (
                      <ShareIcon fontSize="small" />
                    ) : (
                      ""
                    )}
                  </IconButton>
                  <IconButton
                    size="small"
                    aria-label="save"
                    sx={{ fontSize: "16px" }}
                    onClick={() => handleJobSave(job?.job_id)}
                  >
                    {job?.is_saved ? (
                      <BookmarkIcon fontSize="small" />
                    ) : (
                      <BookmarkBorderIcon fontSize="small" />
                    )}
                  </IconButton>
                </Box>
                {/* <Link to={`/applicant-page/${job?.job_id}`}> */}
                <Box onClick={() => handleSingleApplicantClick(job)}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 0.5,
                      mb: 0.5,
                    }}
                  >
                    {/* {logourl[job.id] ? ( */}
                    <img
                      width="55px"
                      height="55px"
                      src={
                        job.logo
                          ? job.logo
                          : "https://www.shutterstock.com/image-vector/image-icon-trendy-flat-style-600nw-643080895.jpg"
                      }
                      alt="logo"
                    />
                  </Box>

                  <Box>
                    {/* Job Role */}
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: 600,
                        fontSize: "16px",
                        color: "black",
                      }}
                    >
                      {job?.role}
                    </Typography>
                    {/* Company Name */}
                    <Typography
                      variant="body2"
                      sx={{
                        textAlign: "start",
                        fontSize: "16px",
                        color: "#00000099",
                        p: "3px",
                      }}
                    >
                      {job?.company_name}
                    </Typography>
                  </Box>

                  <Grid
                    container
                    sx={{
                      display: "grid",
                      gridTemplateColumns: "repeat(2, 1fr)",
                      gap: 0.5,
                      my: "3px",
                      // p: 1,
                      overflowX: "visible",
                      "&::-webkit-scrollbar": { display: "none" },
                      scrollbarWidth: "none",
                    }}
                  >
                    {/* Education Level */}
                    <Grid item>
                      <Typography
                        variant="body2"
                        display="flex"
                        alignItems="center"
                        sx={{
                          color: "#000000DE",
                          fontSize: "12px",
                          // bgcolor: '#f5f5f5',
                          p: "5px 5px",
                          borderRadius: 1,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          minWidth: "auto",
                          height: "32px",
                        }}
                      >
                        <SchoolIcon
                          fontSize="small"
                          sx={{
                            mr: 1,
                            color: "#0000008A",
                            width: "16px",
                            height: "16px",
                          }}
                        />
                        {job?.edu_level || "Not Specified"}
                      </Typography>
                    </Grid>

                    {/* Experience */}
                    <Grid item>
                      <Typography
                        variant="body2"
                        display="flex"
                        alignItems="center"
                        sx={{
                          color: "#000000DE",
                          fontSize: "12px",
                          // bgcolor: '#f5f5f5',
                          p: "5px 5px",
                          borderRadius: 1,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          minWidth: "auto",
                          height: "32px",
                        }}
                      >
                        <WorkOutline
                          fontSize="small"
                          sx={{
                            mr: 1,
                            color: "#0000008A",
                            width: "16px",
                            height: "16px",
                          }}
                        />
                        {job?.experience || "Not Specified"}
                      </Typography>
                    </Grid>

                    {/* Salary */}
                    <Grid item>
                      <Typography
                        variant="body2"
                        display="flex"
                        alignItems="center"
                        sx={{
                          color: "#000000DE",
                          fontSize: "12px",
                          // bgcolor: '#f5f5f5',
                          p: "5px 5px",
                          borderRadius: 1,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          minWidth: "auto",
                          height: "32px",
                        }}
                      >
                        <CurrencyRupeeIcon
                          fontSize="small"
                          sx={{
                            mr: 1,
                            color: "#0000008A",
                            width: "16px",
                            height: "16px",
                          }}
                        />
                        {formatSalary(job?.salary) || "Not Specified"}
                      </Typography>
                    </Grid>

                    {/* Location */}
                    <Grid item>
                      <Typography
                        variant="body2"
                        display="flex"
                        alignItems="center"
                        sx={{
                          color: "#000000DE",
                          fontSize: "12px",
                          // bgcolor: '#f5f5f5',
                          p: "5px 5px",
                          borderRadius: 1,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          minWidth: "auto",
                          height: "32px",
                        }}
                      >
                        <LocationOn
                          fontSize="small"
                          sx={{
                            mr: 1,
                            color: "#0000008A",
                            width: "16px",
                            height: "16px",
                          }}
                        />
                        {job?.location?.split(",")[0].trim() || "Not Specified"}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Typography
                    variant="body2"
                    sx={{
                      mb: 1.2,
                      fontSize: "14px",
                      color: "#000000DE",
                      mt: 1,
                    }}
                  >
                    <DescriptionOutlinedIcon
                      fontSize="small"
                      sx={{
                        // mr: 0.5,

                        color: "#0000008A",
                        width: "16px",
                        height: "16px",
                      }}
                    />
                    {(() => {
                      try {
                        // No need to parse, job?.responsibility is already an array
                        const responsibilities = job?.responsibility;

                        if (
                          Array.isArray(responsibilities) &&
                          responsibilities?.length > 0
                        ) {
                          const text = responsibilities.join(" "); // Convert array to string
                          return text.split(" ").slice(0, 10).join(" ") + "..."; // Limit to 10 words
                        }
                      } catch (error) {
                        let text =
                          job?.responsibility ||
                          "Responsibility details not available.";

                        // Ensure text is a string before using split
                        if (Array.isArray(text)) {
                          text = text.join(" "); // Convert array to string
                        }

                        return text.split(" ").slice(0, 10).join(" ") + "..."; // Limit to 10 words
                      }
                    })()}
                    <span
                      style={{
                        color: "#007BFF",
                        cursor: "pointer",
                        marginLeft: 5,
                      }}
                    >
                      ...More
                    </span>
                  </Typography>

                  <Box
                    sx={{
                      p: 0.5,
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "8px",
                      maxHeight: "60px", // Limit height to show 2-3 rows
                      overflow: "hidden",
                    }}
                  >
                    {job?.skills &&
                      parseSkillsArray(job.skills).map((skill, index, arr) => {
                        const maxSkills = 4; // Reduced number of visible skills

                        if (index >= maxSkills) {
                          if (index === maxSkills) {
                            return (
                              <Typography
                                key="more"
                                variant="body2"
                                sx={{
                                  color: "#007BFF",
                                  cursor: "pointer",
                                  fontWeight: "500",
                                  fontSize: "12px",
                                  lineHeight: "20px",
                                  alignSelf: "flex-start",
                                }}
                              >
                                +{arr.length - maxSkills} more
                              </Typography>
                            );
                          }
                          return null;
                        }

                        // Truncate long skill names
                        const truncatedSkill =
                          skill.length > 20
                            ? `${skill.substring(0, 20)}...`
                            : skill;

                        return (
                          <Typography
                            key={index}
                            variant="body2"
                            title={skill} // Show full skill name on hover
                            sx={{
                              color: "gray",
                              fontWeight: "500",
                              fontSize: "12px",
                              lineHeight: "20px",
                              backgroundColor: "#f5f5f5",
                              padding: "2px 8px",
                              borderRadius: "4px",
                              maxWidth: "150px", // Limit maximum width
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {truncatedSkill.trim()}
                          </Typography>
                        );
                      })}
                  </Box>
                  {/* </Link> */}
                </Box>

                <Box
                  sx={{
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    right: 0,
                    p: 2,
                    backgroundColor: "white", // Ensure it covers content below
                    borderTop: "1px solid #eee", // Optional divider
                  }}
                >
                  <ApplicationTrackerforApplicant applicant={job} />
                </Box>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}

      
            <ShareProfile
              open={shareProfileConfig.open}
              onClose={shareProfileConfig.onClose}
              qrCodeUrl={shareProfileConfig.qrCodeUrl}
              showQr={shareProfileConfig.showQr}
              profileType={shareProfileConfig.profileType}
              handleSuccess={shareProfileConfig.handleSuccess}
              handleFailure={shareProfileConfig.handleFailure}
            />
    </Box>
  );
};

export default AppliedSaveJob;
